import React from 'react';

const OccApprovalComponentLoadable = React.lazy(() => import('./OccApprovalComponent'));

export { OccApprovalComponentLoadable };
